import { IProductPricesApi } from "api/interfaces/category-api.type";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";

export function getUpdatedProductPrices(data: IProductPricesApi, products: ICompactProduct[]) {
  const { skuToProductPrice } = data;
  return products.map((product) => ({
    ...product,
    price: skuToProductPrice[product.sku].price,
    wasPrice: skuToProductPrice[product.sku].wasPrice,
    corePrice: skuToProductPrice[product.sku].corePrice,
  }));
}
